import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import Image from 'components/Common/Image/Image'
import Group from 'components/utils/Group'
import { mediaQueryUp } from 'components/utils/breakpoint'

const Container = styled(Group)`
  min-width: 50%;

  ${mediaQueryUp.desktop} {
    min-width: unset;
  }
`

const ImageContainer = styled.div`
  height: ${rem(54)};
  width: ${rem(54)};
`

function AtolTrustIndicator() {
  return (
    <Container direction="vertical" horizontalAlign="center" verticalAlign="center">
      <ImageContainer>
        <Image id="atol-11711-logo" fit="center" dpr={2} />
      </ImageContainer>
    </Container>
  )
}

export default AtolTrustIndicator
